import { Alert, Grid, Stack } from "@mui/material";
import { FormikDatePicker, FormikTextField } from "@shared";
import { FormikProps } from "formik";

import { DutyScheduleFormValues } from "@/pages/duty-schedule/DutySchedule.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<DutyScheduleFormValues>;
}

export function DutyScheduleFormFields({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <Stack pt={2} gap={3}>
      <FormikTextField formik={formik} fieldName="name" label={t("dutySchedule.create.name")} required />

      <Alert severity="info" sx={{ mb: 2 }}>
        {t("dutySchedule.create.overlapHint")}
      </Alert>
      <Grid container columnSpacing={2} rowSpacing={2}>
        <Grid size={6}>
          <FormikDatePicker
            formik={formik}
            fieldName="periodStart"
            label={t("dutySchedule.create.periodStart")}
            required
          />
        </Grid>
        <Grid size={6}>
          <FormikDatePicker
            formik={formik}
            fieldName="periodEnd"
            label={t("dutySchedule.create.periodEnd")}
            minDate={formik.values.periodStart ?? undefined}
            required
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
